import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, Subject, timer, of } from 'rxjs';
import { catchError, concatMap, map, mergeMap, tap } from 'rxjs/operators';
import { Command } from 'src/app/dashboard/service/users.service';
import { CustomToastMessagessService } from 'src/app/map/services/custom-toast-messagess.service';
import { Unit } from 'src/app/units/models/unit';
import { UnitService } from 'src/app/units/services/unit.service';
import { environment } from 'src/environments/environment';

export interface CommandPayload {
  device_id: string;
  unit: string;
  user_id: string;
  user_name: string;
  type: string;
  payload: string;
}

@Injectable({
  providedIn: 'root',
})
export class BroadcastService {
  private _user = {};
  private _units: Unit[] = [];
  private _password: string | undefined;
  private _commands: Command[] = [];
  private responseToCommandsSent$: Subject<any>;
  constructor(
    private http: HttpClient,
    private unitsService: UnitService,
    private customToastMessagess: CustomToastMessagessService,
  ) {
    this.responseToCommandsSent$ = new Subject<any>();
    this.unitsService.getUnits.subscribe((units) => {
      this._units = units;
    });
  }

  get responseToCommandsSent(): Observable<any> {
    return this.responseToCommandsSent$?.asObservable();
  }
  get commandItems() {
    return this._commands;
  }
  set setUser(user: any) {
    this._user = user;
  }
  set setPassword(password: string) {
    this._password = password || environment.pwd;
  }
  set setCommands(cmds: Command[]) {
    this._commands = cmds;
  }

  getCommands(imei: string) {
    const type = this._units.find((item) => item.GNSSIMEI === imei);
    const commands = this._commands
      .filter(
        (item) =>
          item.protocol === type?.device.deviceName && type?.hasIgnition,
      )
      .sort((a, b) => (b.usage_count || 0) - (a.usage_count || 0))
      .slice(0, 3);
    // console.log(
    //   'Saints ----',
    //   imei,
    //   type,
    //   type?.device.deviceName,
    //   commands,
    //   this._commands,
    // );
    return commands;

    // return this._commands.filter((item) => item.protocol === protocol);
  }
  command(cmd: CommandPayload): Observable<any> {
    return this.http.post<any>(environment.broadcast + `commands`, cmd);
  }
  sentCommands(cmds: CommandPayload[]) {
    from(cmds)
      .pipe(
        concatMap((item, index) =>
          timer(index * 1000).pipe(
            // map(() => item)
            map(() => ({
              item,
              toastId: `send-${item.device_id}-${Date.now()}`,
            })),
          ),
        ),
        tap(({ item, toastId }) => {
          console.log('Sending command', item);
          this.customToastMessagess.addCustomToast({
            id: toastId, //`send-${item.device_id}-${Date.now()}`,
            severity: 'info',
            summary: `${item.unit} Comando enviado: ${item.payload}`,
            detail: `Enviando comando al dispositivo ${item.device_id}`,
            data: {
              unit: `Envio:${item.payload}  (dispositivo ${item.device_id})`,
              datetime: `Fecha: ${this.formatDate(new Date())}`,
              dataEvent: null,
              dataHTML: null,
            },
            sticky: false,
            closable: false,
          });
        }),
        //mergeMap((item) => this.setCommand(item)),
        mergeMap(({ item, toastId }) =>
          this.setCommand(item).pipe(
            map((res) => ({
              item: res,
              toastId,
              originalItem: item,
              error: null,
            })),
            catchError((error) => {
              return of({
                item: null,
                toastId,
                originalItem: item,
                error,
              });
            }),
          ),
        ),
        tap(({ item, toastId, originalItem, error }) => {
          if (error) {
            console.error('Error sending command:', error);

            // 🔥 Actualizar el toast de envío para ocultar la barra de progreso y marcar como advertencia
            this.customToastMessagess.updateCustomToastById({
              id: toastId,
              severity: 'info',
              hideProgress: true,
              summary: `${originalItem.unit} Comando enviado: ${originalItem.payload}`,
              detail: `Inconveniente en el envío`,
              data: {
                unit: `Envío: ${originalItem.payload} (dispositivo ${originalItem.device_id})`,
                datetime: `Fecha: ${this.formatDate(new Date())}`,
                dataEvent: null,
                dataHTML: null,
              },
            } as any);

            var msgWarning =
              'El comando no pudo ser procesado. Por favor, intente de nuevo.';

            if (
              (error?.error?.message ?? error?.message) ==
              'Command already sent'
            ) {
              msgWarning =
                'Un comando ya fue enviado. Por favor, espere antes de reintentar.';
            }

            // Mostrar toast de advertencia controlado
            this.customToastMessagess.addCustomToast({
              id: `error-${originalItem.device_id}-${Date.now()}`,
              severity: 'warn',
              summary: `${originalItem.unit} Comando: ${originalItem.payload}`,
              detail: msgWarning,
              data: {
                //unit: ` → Advertencia: ${originalItem.payload} (dispositivo ${originalItem.device_id})`, // warm no muestra unit
                datetime: `Fecha: ${this.formatDate(new Date(error?.error?.timestamp || error?.timestamp))}`,
                dataEvent: null,
                dataHTML: null,
              },
              sticky: false,
              closable: true,
            });
            return;
          }

          // Si no hay error:
          console.log('Saints response from Broadcast', item);

          // 🔥 Actualizar el toast de envío para ocultar la barra de progreso
          this.customToastMessagess.updateCustomToastById({
            id: toastId,
            severity: 'info',
            hideProgress: true,
            summary: `${item?.message[0]?.command?.unit} Comando enviado: ${item?.message[0]?.command?.payload}`,
            detail: `Respuesta recibida`,
            data: {
              unit: `Envio: ${item?.message[0]?.command?.payload}  (dispositivo ${item?.message[0]?.command?.device_id})`,
              datetime: `Fecha: ${this.formatDate(new Date())}`,
              dataEvent: null,
              dataHTML: null,
            },
          } as any);

          this.responseToCommandsSent$.next(item);

          this.customToastMessagess.addCustomToast({
            id: `resp-${item.timestamp}-${Date.now()}`,
            severity: item.type == 'WARNING' ? 'warn' : 'success',
            summary: `${item?.message[0]?.command?.unit} Comando: ${item?.message[0]?.command?.payload}`,
            detail: `${item?.message[1]?.message || item?.message[0]?.query?.body?.message}`,
            data: {
              unit: `Resp.:${item?.message[1]?.message || item?.message[0]?.query?.body?.message}`,
              datetime: `Fecha: ${this.formatDate(new Date(item.timestamp))}`,
              dataEvent: null,
              dataHTML: null,
            },
            sticky: false,
            closable: false,
            //hideProgress: true,
          });
        }),
      )
      .subscribe();
  }
  setCommand(cmd: CommandPayload) {
    return this.http.post<any>(environment.broadcast + `commands`, cmd);
  }

  sentFastCommands(cmds: CommandPayload[]) {
    this.sentCommands(cmds);
  }

  private formatDate(d: Date): string {
    const pad = (n: number, l = 2) => String(n).padStart(l, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }
}
